const differenceInDays = require('date-fns/difference_in_days')

export default (values, isEditing = false) => {
  let errors = {}

  if (!values.eventName) {
    errors.eventName = 'Forneça o nome do evento'
  }

  if (!values.eventDescription) {
    errors.eventDescription = 'Forneça uma descrição para o evento'
  }

  if (!values.accessCode) {
    errors.accessCode = 'Forneça um código para o evento!'
  }

  if (values.accessCode && values.accessCode.length < 6) {
    errors.accessCode = 'O código do evento deve ter mais de 5 caracteres!'
  }

  if (!values.accessPeriodStart) {
    errors.accessPeriodStart = 'Forneça a data de início do evento'
  }

  if (!values.accessPeriodEnd) {
    errors.accessPeriodEnd = 'Forneça a data de encerramento do evento'
  }

  if (
    values.accessPeriodStart &&
    values.accessPeriodEnd &&
    differenceInDays(values.accessPeriodEnd, values.accessPeriodStart) > 15
  ) {
    errors.accessPeriodStart =
      'Duração do evento não pode ser superior a 15 dias'
    errors.accessPeriodEnd = 'Duração do evento não pode ser superior a 15 dias'
  }

  return errors
}
